import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
	paper: {
		backgroundColor: '#525252',
	},
}));

export default useStyles;
